import React, { 
    useState,
    useEffect,
  } from 'react'
  
import toast from 'react-hot-toast';
import Navbar from '../../Components/Navbar/Navbar'
import CorporateProfileTab from '../../Components/TabsProfile/CorporateProfileTab'
import CorporateMemberTab from '../../Components/TabsProfile/CorporateMemberTab'
import url from '../../Assets/alta_logo.png'
import '../../CssFiles/CorporateProfile.css';
import { RotateLoader } from 'react-spinners';
import { 
    Layout,
    Col, 
    Row,
    Space,
    Card, 
    Image,
    Tabs,
    Modal,
    Form,
    Input,
    Button, 
    Dropdown, 
    Select,
    Tag,
} from 'antd';
import {EditOutlined,SwapOutlined,DownOutlined,UserAddOutlined} from '@ant-design/icons';
import { capitalizeEachWord,} from '../../Utils/Common';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'
import { StatusOptions } from '../../Utils/api/DropdownfilterApi';
import { useNavigate, useParams } from "react-router-dom"
  
  const { TabPane } = Tabs;
  const { Meta } = Card;
  const { Item } = Form;
  const { TextArea } = Input;
  
  const CorporateProfile = () => {
    const navigate = useNavigate() 
    const { id } = useParams() 
    const [editStatusForm] = Form.useForm();
    const [changeStatusForm] = Form.useForm();
    
    const [changeStatusModal, setChangeStatusModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [addMemberForm] = Form.useForm();

    //Add member
    const [addMemberModal, setAddMemberModal] = useState(false);
    const [memberOptions, setMemberOptions] = useState([]);
    const [membersLoading, setMembersLoading] = useState(false);
    const selectedMemberIds = Form.useWatch('member_ids', addMemberForm) || [];
    const [memberDetails, setMemberDetails] = useState([]);
    const existingMemberCount = memberDetails?.members?.length || 0;
    const remainingSlots = Math.max(0, 2 - existingMemberCount);

    const [corporateEditModal, setCorporateEditModal] = useState(false);
    const [corporateId, setCorporateId] = useState(false);

    const { callPost, loading } = usePostRequest(() => {
        setCorporateEditModal(false);
        setChangeStatusModal(false);
        setAddMemberModal(false);
        addMemberForm.resetFields();
        fetchMembersData();
    });
    
    const openEditModal = () => {
        setCorporateEditModal(true)
        setCorporateId(memberDetails?.id)
        editStatusForm.setFieldsValue({
            corporate_no: memberDetails.corporate_no || ' ',
            name: memberDetails.name || ' ',
            address_1: memberDetails.address_1 || ' ',
            address_2: memberDetails.address_2 || ' ',
            fax: memberDetails.fax || ' ',
            telephone: memberDetails.telephone || ' ',
            certificate_no: memberDetails.certificate_no || ' ',
            email: memberDetails.email || ' ',
            nature_of_business: memberDetails.nature_of_business || ' ',
        });
    }

    const handleOpenAddMember = async () => {
        if (remainingSlots === 0) {
            toast.error('A corporate can have a maximum of two members.');
            return;
        }

        addMemberForm.resetFields();
        setMemberOptions([]);
        setAddMemberModal(true);
        setMembersLoading(true);

        try {
            const response = await UseGetRequest(
                'corporates/get_available_members',
                { corporate_id: id }
            );

            const members = response?.data?.members;

            if (!Array.isArray(members)) {
                toast.error('Unable to load members.');
                return;
            }

            setMemberOptions(
                members.map((member) => ({
                    value: String(member.id),
                    label: member.member_no
                        ? `${member.member_name} (${member.member_no})`
                        : member.member_name,
                }))
            );
        } catch {
            toast.error('Unable to load members.');
        } finally {
            setMembersLoading(false);
        }
    };

    const handleAddMembers = () => {
        addMemberForm.validateFields().then((values) => {
            callPost(
                'corporates/add_members',
                [
                    { key: 'corporate_id', value: id },
                    { key: 'member_ids', value: values.member_ids },
                ],
                true
            );
        }).catch(() => {
            // Validation messages are displayed by the form.
        });
    };

    const actionItems = [
    {
        key: 'add_member',
        icon: <UserAddOutlined />,
        label: 'Add Corporate Member',
        disabled: remainingSlots === 0,
    },
    {
        key: 'edit',
        icon: <EditOutlined />,
        label: 'Edit',
    },
    {
        key: 'change-status',
        icon: <SwapOutlined />,
        label: 'Change Status',
    },
    ];

    const handleAction = ({ key }) => {
        if (key === 'add_member') {
            handleOpenAddMember();
        }
        if (key === 'edit') {
            openEditModal();
        }

        if (key === 'change-status') {
            changeStatusForm.resetFields();
            setChangeStatusModal(true);
        }
    };

    const handleChangeStatus = () => {
    changeStatusForm.validateFields().then(({ new_status }) => {
        callPost(
        'corporates/change_status',
        { corporate_id: id, new_status },
        false
        );
    }).catch(() => {
        // The form displays its validation message.
    });
    };

    const handleEditCorporate = () => {
        editStatusForm.validateFields().then(values => {
            const newValues = {
                corporate_id: corporateId,
                corporate_no: values.corporate_no || ' ',
                name: values.name || ' ',
                address_1: values.address_1 || ' ',
                address_2: values.address_2 || ' ',
                fax: values.fax || ' ',
                telephone: values.telephone || ' ',
                certificate_no: values.certificate_no || ' ',
                email: values.email || ' ',
                nature_of_business: values.nature_of_business || ' ',
            }

            callPost(
                "corporates/update_corporate", 
                newValues,
                false,
            );
        }).catch(errorInfo => { 
          toast.error('Validation Failed ', errorInfo);
        });
    };
  

    async function fetchMembersData() {
      setIsLoading(true)
      const response = await UseGetRequest("corporates/get_member_corporate", {corporate_id: id});
      if (response?.data) {
        setMemberDetails(response?.data?.member_corporates[0])
      } else {
        setMemberDetails([])
      }    
      setIsLoading(false)
    }

    useEffect(() => {
        fetchMembersData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const CorporateStatusTag = ({ status }) => {
        if (!status) return null;

        const colorClass = ['Active', 'Transferred', 'Assigned'].includes(status)
            ? 'corporate-status-green'
            : status === 'Pending'
            ? 'corporate-status-orange'
            : 'corporate-status-red';

        return (
            <Tag className={`header-status corporate-profile-status ${colorClass}`}>
            {status.toUpperCase()}
            </Tag>
        );
    };

    return (
        <Layout className='page'>
            <Navbar navKey={'corporate'}/>
            {
                isLoading ? (
                    <Layout className='content-container overflow-y center'>
                    <RotateLoader color="#005E30" size={20} />
                    </Layout>
                ) : (
                    <Layout className='content-container overflow-y'>
                        <Row className='custom-padding responsive-tab-inline'>
                            <Col span={24}>
                                <Row className='mb-4'>
                                    <Col 
                                        xs={24} sm={24} md={12} lg={12} xl={12}
                                        onClick={() => navigate('/corporate')}
                                        className='cursor'
                                    >
                                        <span
                                        className='header-container' 
                                        >
                                        CORPORATE PROFILE
                                        </span>
                                    </Col>
                                    <Col
                                        xs={24} sm={24} md={12} lg={12} xl={12}
                                        className="corporate-profile-actions"
                                        >
                                        <Dropdown
                                            menu={{ items: actionItems, onClick: handleAction }}
                                            trigger={['click']}
                                        >
                                            <Button type="primary" className="button-color">
                                            Select Action <DownOutlined />
                                            </Button>
                                        </Dropdown>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col
                                        xs={24} sm={5} md={5} lg={5} xl={5}
                                    >
                                        <Space direction="vertical">
                                        <Card
                                            cover={<Image alt="image" src={url} />}
                                            className="square-image"
                                        >
                                            <Meta
                                                className="avatar-container"
                                                title={
                                                    <>
                                                    {memberDetails?.status && (
                                                        <div className="corporate-profile-status-container">
                                                        <CorporateStatusTag status={memberDetails.status} />
                                                        </div>
                                                    )}

                                                    <div>{capitalizeEachWord(memberDetails?.name)}</div>
                                                    </>
                                                }
                                            />
                                            <div 
                                                className='mt-2'
                                            > 
                                                <p>Corporate ID: {memberDetails?.corporate_no}</p>  
                                            </div>
                                        </Card>
                                        </Space>
                                    </Col>
                                    <Col xs={24} sm={19} md={19} lg={19} xl={19}>
                                        <Tabs
                                        // activeKey={selectedTab}
                                        id="PO-tabs"
                                        className="profile-tabs"
                                        type="card"
                                        animated="true"
                                        size="medium"
                                        // onChange={(e) => {
                                        //   setSelectedTab(e)
                                        // }}
                                        >
                                        <TabPane key="profile" tab="Profile">
                                            <CorporateProfileTab
                                                memberData={memberDetails}
                                            />
                                        </TabPane>
                    
                                        <TabPane key="members" tab="Members">
                                            <CorporateMemberTab
                                                memberData={memberDetails}
                                                fetchMembersData={fetchMembersData}
                                                isLoading={isLoading}
                                            />
                                        </TabPane>
                                        
                                        </Tabs>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Modal
                            title="Edit Corporate"
                            open={corporateEditModal}
                            onOk={handleEditCorporate}
                            onCancel={() => setCorporateEditModal(false)}
                            okText="Save"
                            maskClosable={false}
                            width={800} 
                            loading={loading}
                        >
                            <Form 
                                form={editStatusForm} 
                                layout="vertical"
                            >
                                <Row>
                                    <Col span={12} className='p-2'>
                                        <Item
                                            label="Corporate ID"
                                            name="corporate_no"
                                            rules={[{ required: true, message: 'Please select a Corporate ID' }]}

                                        >
                                            <Input/>
                                        </Item>
                                    </Col>
                                    <Col span={12} className='p-2'>
                                        <Item
                                            label="Name"
                                            name="name"
                                            rules={[{ required: true, message: 'Please select a Name' }]}
                                        >
                                            <Input/>
                                        </Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={12} className='p-2'>
                                        <Item
                                            label="Address 1"
                                            name="address_1"
                                        >
                                            <Input/>
                                        </Item>
                                    </Col>
                                    <Col span={12} className='p-2'>
                                        <Item
                                            label="Address 2"
                                            name="address_2"
                                        >
                                            <Input/>
                                        </Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={12} className='p-2'>
                                        <Item
                                            label="Fax"
                                            name="fax"
                                        >
                                            <Input/>
                                        </Item>
                                    </Col>
                                    <Col span={12} className='p-2'>
                                        <Item
                                            label="Telephone"
                                            name="telephone"
                                        >
                                            <Input/>
                                        </Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={12} className='p-2'>
                                        <Item
                                            label="Email"
                                            name="email"
                                        >
                                            <Input/>
                                        </Item>
                                    </Col>
                                    <Col span={12} className='p-2'>
                                        <Item
                                            label="Certificate Number"
                                            name="certificate_no"
                                        >
                                            <Input/>
                                        </Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24}>
                                        <Item
                                            label="Nature of Business"
                                            name="nature_of_business"
                                        >
                                            <TextArea rows={5}/>
                                        </Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Modal>
                        <Modal
                            title="Add Corporate Member"
                            open={addMemberModal}
                            onOk={handleAddMembers}
                            onCancel={() => {
                                setAddMemberModal(false);
                                addMemberForm.resetFields();
                            }}
                            okText="Save"
                            cancelText="Cancel"
                            confirmLoading={loading}
                            okButtonProps={{
                                disabled: membersLoading || remainingSlots === 0,
                            }}
                            maskClosable={false}
                        >
                            <Form form={addMemberForm} layout="vertical">
                                <Form.Item
                                    label="Members"
                                    name="member_ids"
                                    extra={`You can add ${remainingSlots} more member(s).`}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please select at least one member.',
                                        },
                                        {
                                            validator: (_, value = []) =>
                                                value.length <= remainingSlots
                                                    ? Promise.resolve()
                                                    : Promise.reject(
                                                        new Error(
                                                            'A corporate can have a maximum of two members.'
                                                        )
                                                    ),
                                        },
                                    ]}
                                >
                                    <Select
                                        mode="multiple"
                                        showSearch
                                        allowClear
                                        placeholder="Select members"
                                        optionFilterProp="label"
                                        loading={membersLoading}
                                        disabled={membersLoading || remainingSlots === 0}
                                        options={memberOptions.map((option) => ({
                                            ...option,
                                            disabled:
                                                selectedMemberIds.length >= remainingSlots &&
                                                !selectedMemberIds.includes(option.value),
                                        }))}
                                    />
                                </Form.Item>
                            </Form>
                        </Modal>
                        <Modal
                            title="Change Status"
                            open={changeStatusModal}
                            onOk={handleChangeStatus}
                            onCancel={() => setChangeStatusModal(false)}
                            okText="Save"
                            okButtonProps={{ loading }}
                            >
                            <Form form={changeStatusForm} layout="vertical">
                                <Form.Item label="Corporate">
                                <Input value={memberDetails?.name || ''} disabled />
                                </Form.Item>

                                <Row gutter={12}>
                                <Col span={12}>
                                    <Form.Item label="Old Status">
                                    <Input value={memberDetails?.status || ''} disabled />
                                    </Form.Item>
                                </Col>

                                <Col span={12}>
                                    <Form.Item
                                    label="New Status"
                                    name="new_status"
                                    rules={[{ required: true, message: 'Please select a status' }]}
                                    >
                                    <Select
                                        placeholder="Select Status"
                                        options={StatusOptions().filter(
                                        option => option.value && option.value !== memberDetails?.status
                                        )}
                                    />
                                    </Form.Item>
                                </Col>
                                </Row>
                            </Form>
                        </Modal>
                                        
                    </Layout>
                )
            }
        </Layout>        
    )
  }
  
  export default CorporateProfile
  